const swiper = new Swiper('#swiper', {
    spaceBetween: 0,
    loop: true,
    // autoplay: {
    //     delay: 4000
    // },
    speed: 500,
    pagination: {
      el: '.swiper-pagination',
    },
  
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

const merchSwiper = new Swiper('#swiper-merch', {
    spaceBetween: 0,
    loop: true,
    autoplay: {
        delay: 4000,
        pauseOnMouseEnter: true
    },
    speed: 500,
    pagination: {
      el: '.swiper-pagination',
    },
  
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

  const swiperCannabis = new Swiper('#swiper-cannabis', {
    slidesPerView: 4,
    spaceBetween: 0,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
    },
    
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

  // const tabs = document.querySelectorAll('.navtab');
  // const tabs_b = document.querySelectorAll('.navtab-2');
  // const apContents = document.querySelectorAll('.swiper-cannabis');
  // const underline = document.querySelector('.underline');
  // const swiperWrapperContainer = document.querySelector('.swiper-cannabis-wrapper');

//   function createSlide(item, i) {
//     // Create the new div element
//     let newDiv = document.createElement('div');
//     let innerDiv = document.createElement('div')
//     let innerDiv_top = document.createElement('div')
//     let paraHeading = document.createElement('p')
//     let itemTitle = document.createElement('h3')
//     newDiv.classList.add('swiper-slide', 'swiper-slide-item');
//     innerDiv.classList.add('swiper-slide-item_info')
//     paraHeading.classList.add('swiper-slide-item-heading')
//     itemTitle.classList.add('swiper-slide-item-title')
//     paraHeading.innerText = 'All-In-One Device'
//     itemTitle.innerText = item.name
    

//     // Create the img element and set its attributes
//     let imgElement = document.createElement('img');
//     let img_hover_elment = document.createElement('img');
//     imgElement.src = item.image;  // Set the source of the image
//     imgElement.alt = item.name;  // Set the alt text of the image
//     img_hover_elment.src = item.image_hover
//     img_hover_elment.alt = 'product hover'

//     // Create the buy button element and set its attributes
//     let link = "/product/cannabis.html";
//     let buyButton = document.createElement("a");
//     buyButton.setAttribute("href", link);
//     buyButton.innerHTML = "Learn More";

//     innerDiv_top.appendChild(imgElement)
//     innerDiv_top.appendChild(img_hover_elment)
//     innerDiv_top.classList.add('swiper-item-img-container')
//     // Append the img and button elements to the new div
//     innerDiv.appendChild(paraHeading)
//     innerDiv.appendChild(itemTitle)
//     innerDiv.appendChild(buyButton)
//     newDiv.appendChild(innerDiv_top)
//     newDiv.appendChild(innerDiv)
//     newDiv.setAttribute('data-swiper-slide-index', i)

//     return newDiv;
// }

// let slides = cannabis.filter(item => item.blend === 'original').map((item, i) => createSlide(item, i));

// if (swiperWrapperContainer) {
//     slides.forEach(slide => swiperWrapperContainer.appendChild(slide));
// } else {
//     console.log('swiper-wrapper element not found');
// }

  // function setQueryParam(param, value) {
  //   let url = new URL(window.location.href);
  //   let params = new URLSearchParams(url.search);
  //   params.set(param, value);
  //   url.search = params.toString();
  //   window.history.pushState({}, '', url);
  // }


  // function setContentActive(tab) {
  //   const target = tab.getAttribute('data-target');
  //     apContents.forEach(content => {
  //       if (content.id === target) {
  //         content.classList.add('ap-content-active');
  //       } else {
  //         content.classList.remove('ap-content-active');
  //       }
  //     });
  //     updateUnderline();
  // }
  
  // function updateUnderline() {
  //   const activeTab = document.querySelector('.navtab.ap-active');
  //   underline.style.width = `${activeTab.offsetWidth}px`;
  //   underline.style.left = `${activeTab.offsetLeft}px`;
  // }
  
//   tabs.forEach(tab => {
//     tab.addEventListener('click', () => {
//       tabs.forEach(t => t.classList.remove('ap-active'));
//       tab.classList.add('ap-active');
//       const target = tab.getAttribute('data-target');

//       // let slides = cannabis.filter(item => item.blend === target).map((item, i) => createSlide(item, i));

//       // console.log('function ran')
//       // swiperWrapperContainer.style.visibility = "hidden"
//       // swiperWrapperContainer.innerHTML = ''
//       // swiperWrapperContainer.style.visibility = 'visible'


//       // slides.forEach(slide => swiperWrapperContainer.appendChild(slide));

//       setQueryParam('category', target)
//       updateUnderline();
//   });
// });

// tabs_b.forEach(tabb => {
//     tabb.addEventListener('click', () => {
//       tabs_b.forEach(t => t.classList.remove('ap-active'));
//       tabb.classList.add('ap-active');
//       const target = tabb.getAttribute('data-target');

//       const lists = document.querySelectorAll('.product-list')
//       lists.forEach(list => {
//         list.style.display = 'none'
//         if(list.getAttribute('id') === target){
//             list.style.display = 'grid'
//         }
//       })
    

//       setQueryParam('category', target)
//       updateUnderline();
//   });
// });

  // function setActiveTabFromURL() {
  //   const params = new URLSearchParams(window.location.search);
  //   const activeTab = params.get('category');
    
  //   if (activeTab) {
  //     document.querySelectorAll('.navtab').forEach(tab => {
  //       if (tab.getAttribute('data-target') === activeTab) {
  //         const target = tab.getAttribute('data-target');
  //         apContents.forEach(content => {
  //           if (content.id === target) {
  //             content.classList.add('ap-content-active');
  //           } else {
  //             content.classList.remove('ap-content-active');
  //           }
  //         });
          
  //         tab.classList.add('ap-active');
  //         updateUnderline();
  //       } else {
  //         tab.classList.remove('ap-active');
  //       }
  //     });
  //   }
  // }

// updateUnderline();
// window.addEventListener('resize', updateUnderline);
// window.addEventListener("load", setActiveTabFromURL);

// document.addEventListener("DOMContentLoaded", function() {
//     var acc = document.getElementsByClassName("accordion");
//     var i;

//     for (i = 0; i < acc.length; i++) {
//         acc[i].addEventListener("click", function() {
//             this.classList.toggle("active");
//             var panel = this.nextElementSibling;
//             if (panel.style.display === "block") {
//                 panel.style.display = "none";
//             } else {
//                 panel.style.display = "block";
//             }
//         });
//     }
// });



const body = document.body 
let lastscroll = 0;

window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY

    if(currentScroll <= 0) {
        // console.log(currentScroll <= 0)
        body.classList.remove('scroll-up')
    }

    if(currentScroll > lastscroll && !body.classList.contains('scroll-down')) {
        body.classList.remove('scroll-up')
        body.classList.add('scroll-down')
    }

    if(currentScroll < lastscroll && body.classList.contains('scroll-down')) {
        body.classList.remove('scroll-down')
        body.classList.add('scroll-up')
    }

    lastscroll = currentScroll
})

$(".accordianNav h3.dropArrow").click(function() {
    $("h3.dropArrow").removeClass("active");
    $(".accordianNav ul ul").slideUp();
    if (!$(this).next().is(":visible")) {
        $(this).next().slideDown();
        $(this).addClass("active");
    }
})

$(".fa-bars").click(function() {
    $('.accordianNav').animate({
        right: '0%'
    }, 300);
})
$(".accordianNav-header span").click(function() {
    $('.accordianNav').animate({
        right: '100%'
    }, 300);
})

// document.addEventListener("DOMContentLoaded", function() {
//     if (window.location.pathname !== "/") {
//         console.log('Not root')
//         var nav = document.querySelector("header.lt-main-nav");
//         var mobilenav = document.querySelector('.mobile-navbar')
//         var logoImg = document.querySelector('.lt-logo')
//         var logoMobile = document.querySelector('.mobile-logo')
//         var cart = document.querySelector('.lt-cart')
//         var mcart = document.querySelector('.mobile-cart')
//         var mobileMenu = document.querySelector('.fa-bars')

//         console.log(cart)

//       mobilenav.style.background = '#fff'
//         // logoMobile.style.filter = 'initial';
//         // mobileMenu.style.color = '#101010';
//         nav.style.background = '#fff';
//         nav.style.color = '#101010';
//         logoImg.style.filter = 'initial';
//         cart.setAttribute('fill', '#101010');
//         // mcart.setAttribute('fill', '#101010');
//     }
// });



// // Инициализация превью слайдера
// const sliderThumbs = new Swiper('.slider__thumbs .swiper-container', { // ищем слайдер превью по селектору
// 	// задаем параметры
// 	direction: 'vertical', // вертикальная прокрутка
// 	slidesPerView: 3, // показывать по 3 превью
// 	spaceBetween: 24, // расстояние между слайдами
// 	navigation: { // задаем кнопки навигации
// 		nextEl: '.slider__next', // кнопка Next
// 		prevEl: '.slider__prev' // кнопка Prev
// 	},
// 	freeMode: true, // при перетаскивании превью ведет себя как при скролле
// 	breakpoints: { // условия для разных размеров окна браузера
// 		0: { // при 0px и выше
// 			direction: 'horizontal', // горизонтальная прокрутка
// 		},
// 		768: { // при 768px и выше
// 			direction: 'vertical', // вертикальная прокрутка
// 		}
// 	}
// });
// // Инициализация слайдера изображений
// const sliderImages = new Swiper('.slider__images .swiper-container', { // ищем слайдер превью по селектору
// 	// задаем параметры
// 	direction: 'vertical', // вертикальная прокрутка
// 	slidesPerView: 1, // показывать по 1 изображению
// 	spaceBetween: 0, // расстояние между слайдами
// 	mousewheel: true, // можно прокручивать изображения колёсиком мыши
// 	navigation: { // задаем кнопки навигации
// 		nextEl: '.slider__next', // кнопка Next
// 		prevEl: '.slider__prev' // кнопка Prev
// 	},
// 	grabCursor: true, // менять иконку курсора
// 	thumbs: { // указываем на превью слайдер
// 		swiper: sliderThumbs // указываем имя превью слайдера
// 	},
// 	breakpoints: { // условия для разных размеров окна браузера
// 		0: { // при 0px и выше
// 			direction: 'horizontal', // горизонтальная прокрутка
// 		},
// 		768: { // при 768px и выше
// 			direction: 'vertical', // вертикальная прокрутка
// 		}
// 	}
// });



